import { useMutation } from "@tanstack/react-query";
import previewSql from "api/scheduledReports/previewSql";

import { toast } from "react-toastify";

export default function usePreviewSqlMutation() {
  return useMutation({
    mutationFn: previewSql,
    onSuccess: (data) => {
      toast.success(data.message || "Preview successfully.");
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
}
